module.exports = __webpack_public_path__ + "img/5501.bcc0179b.png";